import React from "react";
import clsx from "clsx";

import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import { useGetLocationData, useSetLocationData } from "~/hooks/locationData";
import { ROW_CHECK_OPTIONS } from "./options";
import { LOCALIZE_NAME_OPTIONS } from "~/constans/commom";

import Button from "~/shared/ui/Fields/Button";

import Default from "~/components/Icons/icon-default";
import Delete from "~/components/Icons/delete-cross";
import s from "./TableRow.less";

interface IProps {
  options: string[];
  nameChildren?: string[];
  type: string;
  btnEdit?: boolean;
  btnView?: boolean;
  btnVersion?: boolean;
  btnDel?: boolean;
  item;
}

const SubdivisionTableRow: React.FC<IProps> = ({
  options = [],
  nameChildren = [],
  item = {},
  btnEdit = false,
  btnView = false,
  btnDel = false,
  btnVersion = false,
  type,
}) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { sortField } = useGetLocationData();
  let lang = localStorage.getItem("language");
  const setData = useSetLocationData();
  const withBtns = btnEdit || btnDel || btnView || btnVersion;
  const isUsersType = type === "users";

  const restore = type === "editorSubdivision" || item.status === "active";

  const goToId = (e) => {
    e.target.dataset.option_name === ROW_CHECK_OPTIONS.DealerName &&
      history.push(`${item.id}`);
  };

  const openEditModal = () => {
    type !== "employee"
      ? setData("openModal", "Edit", "currentId", item.id)
      : history.push(`${item.id}`);
  };

  const openDelModal = () => {
    setData("openModal", "Delete", "currentId", item.id);
  };

  const commonName = lang === "en" ? nameChildren[1] : nameChildren[0];

  return (
    <>
      <tr className={s.row_tr}>
        {options?.map((optionName) => (
          <td
            style={{ maxWidth: 100, overflow: "hidden" }}
            className={clsx({
              [s.sort_active]:
                sortField ===
                (type === "indicators"
                  ? optionName === "name"
                    ? commonName
                    : optionName
                  : LOCALIZE_NAME_OPTIONS.includes(optionName) && lang === "en"
                  ? `${optionName}En`
                  : optionName),
              [s.remove]: type === "users" && item.status === "removed",
            })}
            key={optionName}
            data-option_name={optionName}
            onClick={goToId}
          >
            <div>
              {optionName === ROW_CHECK_OPTIONS.role ||
              optionName === ROW_CHECK_OPTIONS.unit ||
              optionName === ROW_CHECK_OPTIONS.period ||
              (type === "users" && optionName === ROW_CHECK_OPTIONS.status) ? (
                <span className={s.cont}>
                  {t(`${type}.${item[optionName]}`)}
                </span>
              ) : (
                <span className={s.cont}>{item[optionName]}</span>
              )}
            </div>
          </td>
        ))}

        {withBtns && (
          <td
            className={clsx(s.with_btn, {
              [s.btn_employ]: type === "employee",
            })}
          >
            {btnEdit && (
              <div className={s.cont}>
                <Button small txtBtn={t("ui.btn_edit")} onClick={openEditModal}>
                  <Default />
                </Button>
              </div>
            )}

            {btnDel && (
              <div className={s.cont}>
                <Button
                  small
                  txtBtn={restore ? t("ui.btn_del") : t("ui.btn_restore")}
                  empty
                  onClick={openDelModal}
                >
                  <Delete />
                </Button>
              </div>
            )}
          </td>
        )}
      </tr>
    </>
  );
};
export default SubdivisionTableRow;
